<template>
  <router-link 
    v-lazy 
    :data-src="'url(/media/' + item.thumb + ')'" 
    :to="'/project/' + item.id"
    class="item"
  >
    <img v-if="item.images.length" src="/images/icon-layers.svg" class="multi-images">
    <div v-html="item.title" :class="['title', {'mobile-title': store.showMobile}]" />
  </router-link>
</template>
  
<script lang="ts">
import { PropType, defineComponent } from 'vue'
import { useMainStore, typeMediaItem } from '../store'
export default defineComponent({
  name: "MediaBlockItem",
  props: {
    item: {
      type: Object as PropType<typeMediaItem>,
      required: true
    }
  },
  data() {
    return {
      store: useMainStore(),
    };
  },
})
</script>
  
<style scoped>
.item {
  position: relative;
  aspect-ratio: 15.8/9;
  border-radius: .5rem;
  overflow: hidden;
  background-color: #dedede;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all 2s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.title {
  position: absolute;
  display: grid;
  align-items: center;
  justify-items: center;
  bottom: 0;
  width: 100%;
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.75);
  color: black;
  font-size: 1rem;
  transform: translateY(100%);
  transition: all .7s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.item:hover .title {
  transform: translateY(0);
  transition: all .7s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.item:hover {
  background-size: 100% !important;
  transition: all 2s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.multi-images {
  position: absolute;
  background-color: white;
  padding: 0.2rem;
  border-radius: 0.3rem;
  opacity: .3;
  height: 1.5rem;
  left: 0.5rem;
  top: 0.5rem;
}

/* ================ */
/* Мобильная версия */
/* ================ */

.mobile-title {
  transform: translateY(0);
  padding: 1rem;
}
</style>
  